<div class="buttons flex flex-wrap px-2">
  @for (language of otherChoices(); track language) {
    <button mat-button (click)="changeLocale(language)">{{ language | uppercase }}</button>
  }
</div>